import { render, staticRenderFns } from "./AthleteProfilesManagement.vue?vue&type=template&id=c355a95c&"
import script from "./AthleteProfilesManagement.vue?vue&type=script&lang=ts&"
export * from "./AthleteProfilesManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports